import React, { useEffect, useState } from 'react'
import '../css/Images.css'
import {getDownloadURL, getStorage, ref, uploadBytes} from 'firebase/storage'
import app from '../firebase'
import axios from '../axios'
import {useNavigate} from 'react-router-dom'
const Images = () => {
  const[desc, setDesc] = useState('')
  const[file, setFile] = useState(null)
  const[toggle, setToggle] = useState(null)
  const[code, setCode] = useState(null)
  const[password, setPassword] = useState('')
  const[posts, setPosts] = useState([])
  const navigate = useNavigate()
  const storage = getStorage(app)
  useEffect(() => {
     axios.get('/posts').then(res => {
        setPosts(res.data.reverse())
     })
  }, [])
  return (
    <div className="imagesContainer">
       <div className="postImage">
           {code ?(
             <>
                <input className="descInput" onChange={(e) => {
              setDesc(e.target.value)
           }}type="text" placeholder="Description" />
           <input type="file" onChange={(e) => {
                setFile(e.target.files[0])
           }}/>
            <button className="submitBtn" onClick={() => {
               const imgRef = ref(storage, `images/${Math.floor(Math.random() * 100000000000000).toString() + Math.floor(Math.random() * 100000000000000).toString() + Math.floor(Math.random() * 100000000000000).toString() + Math.floor(Math.random() * 100000000000000).toString()}`)
               uploadBytes(imgRef, file).then(res => {
                  getDownloadURL(imgRef).then(url => {
                     axios.post('/new/post', {
                        imageURL: url,
                        description: desc
                     })
                  })
               })
               setCode(false)
               setToggle(false)
               alert("Photo Uploaded")
           }}>Upload Post</button>
             </>
           ) : (
              <>
                 {toggle ? (
                    <>
                        <input className="descInput" placeholder="Code..." type="password" onChange={(e) => {setPassword(e.target.value)}} />
                 <button  className="submitBtn" onClick={() => {
                    axios.get(`/authcode?password=${password}`).then(res => {
                        setCode(res.data)
                        if (!res.data) {
                            alert("Code Invailid")
                        }
                    })
                 }}>Enter</button>
                    </>
                 ) : (
                    <button className="submitBtn" onClick={()=>{
                        setToggle(!toggle)
                    }}>Upload</button>
                 )}
              </>
           )}
         
       </div>
       <div className="images">
            {posts.map(post => (
                <div className="imgCard">
                    <img src={post.imageURL} alt="Image" />
                    <p>{post.description}</p>
                </div>
            ))}
       </div>
    </div>
  )
}

export default Images